<template>
  <div class="list-analytics" style="position:relative;height:200px;" :rscUnit="rscUnit" @mouseover="onShowChartButton" @mouseleave="onHideChartButton" v-loading="isLoading">
    <el-row class="chart-button-wrapper" type="flex" justify="space-between">
      <span class="chart-button" style="float:left;" v-show="showChartFuncButton || selectHiddenFlag">
        <el-tooltip effect="dark" content="Smart Analyzer" placement="bottom">
          <el-button size="small" v-show="showSmartAnalyzer" class="customised-icon analyze" style="background-color:white" @click="onClickForecastButton"></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="기간비교 그래프" placement="bottom">
          <el-button size="small" v-show="showCompare" class="customised-icon comparison" style="background-color:white" @click="onClickCompareButton"></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="실시간차트" placement="bottom">
          <el-button size="small" v-show="showRealtime" @click="onClickRealtimeButton" :disabled="realtimeFlag"><i class="fas fa-play text-small" /></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="일시중지" placement="bottom">
          <el-button size="small" v-show="showPause" @click="onClickPauseButton"><i class="fas fa-pause text-small" /></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="정지" placement="bottom">
          <el-button size="small" v-show="showStop" @click="onClickRealtimeStopButton"><i class="fas fa-stop text-small" /></el-button>
        </el-tooltip>
        <slot name="customizeButton"/>
        <el-select v-if="!(this.showStop) && statTypeFlag && isShowStatType" style="width: 70px;" v-model="statType" @change="onChangeStatType" @visible-change="onVisibleChangeSelect">
          <el-option label="최대" value="MAX"></el-option>
          <el-option label="평균" value="AVG"></el-option>
          <el-option label="최소" value="MIN"></el-option>
        </el-select>
      </span>
      <span v-show="onlyMonitoringFlag" style="float:left;"/>
      <span class="chart-button" style="float:right;" v-show="isShowChartButton">
        <el-tooltip effect="dark" content="삭제" placement="bottom">
          <el-button size="small" v-show="showDelete" @click="onDeleteChart"><i class="fas fa-times" /></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="초기화" placement="bottom">
          <el-button v-show="showRefreshButton" size="small" @click="onRefreshChart"><i class="fas fa-sync-alt" /></el-button>
        </el-tooltip>
      </span>
    </el-row>

    <div class="t-chart">
      <highcharts class="chart" style="padding-left:0px;marign-left:0px;top:0px;" :options="options" ref="highchart" />
      <el-scrollbar class="status" v-if="legendPosition == 'right'" >
        <ul class="list list-event">
          <li v-for="point in legendPoints" :key="point.key" :class="getLegendClass(point.series)" :style="{borderColor: point.color}" >
            <span class="number">{{ convertValuByUnit(point) }}</span>
            <el-tooltip placement="bottom">
              <div slot="content">
                <ul>
                  <li>{{ convertObjName(point.series) }}</li>
                  <li>{{ convertLegendName(point.series) }}</li>
                </ul>
              </div>
              <span class="content" @click="onClickLegend(point.series)">
                <strong>{{ convertObjName(point.series) }}</strong>
                <span>{{ convertLegendName(point.series) }}</span>
              </span>
            </el-tooltip>
            <span v-if="deleteFlag" @click="onDeleteSeries(point)"><i class="fas fa-times" /></span>
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <div style="width: 100%; text-align: center;">
      <el-scrollbar class="status" v-if="legendPosition == 'bottom'" >
        <ul class="list list-event">
          <li v-for="point in legendPoints" :key="point.key" :class="getLegendClass(point.series)" :style="{borderColor: point.color}" >
            <span class="number">{{ convertValuByUnit(point) }}</span>
            <el-tooltip placement="bottom">
              <div slot="content">
                <ul>
                  <li>{{ convertObjName(point.series) }}</li>
                  <li>{{ convertLegendName(point.series) }}</li>
                </ul>
              </div>
              <span class="content" @click="onClickLegend(point.series)">
                <strong>{{ convertObjName(point.series) }}</strong>
                <span>{{ convertLegendName(point.series) }}</span>
              </span>
            </el-tooltip>
            <span v-if="deleteFlag" @click="onDeleteSeries(point)"><i class="fas fa-times" /></span>
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <!-- 기간비교 그래프 팝업창 -->
    <w-resource-compare-period-popup ref="comparePeriodPopup" :rsc-info-list="periodRscInfoList"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import map from 'lodash/map';
import find from 'lodash/find';
import remove from 'lodash/remove';
import matches from 'lodash/matches';
import pick from 'lodash/pick';
import pullAt from 'lodash/pullAt';
import has from 'lodash/has';
import forEach from 'lodash/forEach';
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';
import moment from 'moment';

import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
import chartUtils from '@/utils/charts';
import { lineOptions } from '@/constants/chart-options';
import { plotCharts } from '@/mixins/performance/charts';
import AnalysisChartAPI from '@/api/performance/analysis/analysis-chart';
import ChartAPI from '@/api/chart/chart-analysis';
import WResourceComparePeriodPopup from '@/components/popup/ResourceComparePeriodPopup';
import WImportTemplatePopup from '../popup/ImportTemplatePopup';

export default {
  name: 'WCommonLineChart',
  components: {
    WResourceComparePeriodPopup,
    WImportTemplatePopup,
  },
  mixins: [plotCharts],
  props: {
    added: Boolean, // 차트 추가 여부
    rscInfoList: Array,
    orderbyIndex: Number,
    deleteFlag: {
      type: Boolean,
      default: true,
    },
    realtimeFlag: Boolean,
    chartHeight: {
      type: String,
      default: '200',
    },
    onlyMonitoringFlag: { // 모니터링 전용 차트의 경우 마우스 오버 시 삭제 버튼만 보인다.
      type: Boolean,
      default: false,
    },
    extraChartOptions: Object,
    rawDataFlag: { // 조회 범위 (isRelative)에 상관없이, 실시간 성능 데이터 (perfhist index)만 조회한다.
      type: Boolean,
      default: false,
    },
    isShowSmartAnalyzerButton: {
      type: Boolean,
      default: true,
    },
    isShowCompareButton: {
      type: Boolean,
      default: true,
    },
    isShowStatType: {
      type: Boolean,
      default: true,
    },
    isShowDeleteButton: {
      type: Boolean,
      default: true,
    },
    legendPosition: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      options: cloneDeep(lineOptions),
      rscUnit: null,
      forecastButton: null,
      rscItems: [],
      // interval: {},
      realtimeChartTask: 'realtimeChartTask',
      realtimeSeries: [],
      isShowChartButton: false,
      periodRscInfoList: [],
      showPause: false,
      showStop: false,
      isLoading: false,
      statType: 'AVG',
      statTypeFlag: true,
      selectHiddenFlag: false,
      lastCheckDatetime: null,
    };
  },
  computed: {
    showSmartAnalyzer() {
      return this.isShowSmartAnalyzerButton;
    },
    showCompare() {
      return this.isShowCompareButton;
    },
    showRealtime() {
      return !this.showStop || !this.showPause;
    },
    showRefreshButton() {
      return !this.added;
    },
    showChartFuncButton() {
      return this.isShowChartButton && !this.onlyMonitoringFlag;
    },
    showDelete() {
      return this.isShowDeleteButton;
    },
    ...mapGetters(['analysisDateParams', 'isRelativeAnalysisDate', 'plotLineDatetime']),
  },
  watch: {
    rscInfoList: {
      immediate: true,
      handler(rscInfoList) {
        this.rscItems = rscInfoList;
        this.statType = 'AVG'; // 초기화
        this.onShowChart();
      },
    },
    analysisDateParams: {
      handler() {
        this.statType = 'AVG';
      },
    },
    showRealtime(flag) {
      // 나머지 차트 disabled
      this.$emit('setRealtimeChart', this.$refs.highchart.chart, flag);
    },
    statType(value) {
      this.$emit('set-chart-stat-type', value, this.rscInfoList);
    },
  },
  mounted() {
    const newOptions = this.options;
    const me = this;
    // 차트의 height 설정

    Object.assign(newOptions.chart, { height: this.chartHeight });
    Object.assign(newOptions.plotOptions.series, {
      point: {
        events: {
          mouseOver(e) {
            me.$emit('mouseOver', this, e);
          },
        },
      },
      events: {
        mouseOut() {
          if (isEmpty(me.plotLineDatetime)) {
            me.setCustomTooltip('init');
          } else {
            me.setCustomTooltip('plotLine');
          }

          me.$emit('mouseOut');
        },
        click(e) {
          me.$emit('clickChart', this.chart, e);
        },
      },
    });

    newOptions.chart.events = {
      load() {
        if (has(this, 'series')) {
          const series = this.series;
          // 시리즈가 8개 이상일 경우 최대 8개만 표현하고 나머지는 hidden처리한다.
          if (series.length > 8) {
            const excessSeries = series.slice(8, series.length);
            excessSeries.forEach((line) => line.hide());
          }
        }
        me.$emit('updateChart', this, me.orderbyIndex);
      },
      click(e) {
        me.$emit('clickChart', this, e);
      },
    };

    newOptions.tooltip = {
      formatter() {
        return getDateToString(this.key, 'YYYY-MM-DD HH:mm:ss');
      },
    };

    if (!isEmpty(this.extraChartOptions)) {
      Object.assign(newOptions.chart, this.extraChartOptions);
    }
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.realtimeChartTask);
  },
  methods: {
    /**
     * 삭제된 시리즈를 제외한 나머지만 서버요청한다.
     * 통계타입(최대, 평균, 최소)가 추가됨에 따라 statType추가, 6시간 이내 조회는 실시간 데이터이며 통계타입을 제공하지않는다. (2019. 10. 18 - Song)
     *
     * @return {[type]} [description]
     * @author jda
     */
    onShowChart() {
      remove(this.realtimeSeries); // 초기화
      let rscInfoList = this.rscItems;
      if (isEmpty(rscInfoList)) {
        return;
      }
      // 6시간 전 시간 계산
      const realtimeCheck = moment()
        .subtract(6, 'hour')
        .subtract(5, 'minute')
        .toDate()
        .getTime();
      // 6시간 보다 더 적은 시간 차트라면 통계 타입(최대, 평균, 최소)은 제공하지 않는다. - 6시간 이하는 실시간이기 때문에
      this.statTypeFlag = !isNil(this.analysisDateParams) ? realtimeCheck >= this.analysisDateParams.startDatetime : false;
      // 삭제된 시리즈는 호출하지 않는다.
      rscInfoList = filter(rscInfoList, (record) => isEmpty(record.deleted) || !record.deleted);

      // rscKey가 없을 경우 서버 호출하여 가져오기 때문에 rscItems를 초기화한다.
      this.rscItems = rscInfoList;
      this.requestPerformanceChartData(rscInfoList);
    },
    /**
     * 차트의 성능정보 데이터를 서버에서 조회한다.
     * @param  {[type]} rscInfoList [description]
     * @return {[type]}             [description]
     * @author jda
     */
    requestPerformanceChartData(rscInfoList) {
      const params = Object.assign({}, { rscInfoList, isRelative: this.isRelativeAnalysisDate, statType: this.statTypeFlag ? this.statType : null }, this.analysisDateParams);

      // loadMask 추가
      this.isLoading = true;

      // 대용량 데이터 조회 시 timeout (기본 30초)되는 것을 방지하기 위해 5분으로 늘림
      const chartConfig = {
        timeout: 300000,
      };

      if (!this.rawDataFlag) {
        AnalysisChartAPI.getPerformanceChartData(params, chartConfig).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.options.series = result;
            chartUtils.setYAxisRange(this.options);
            this.$nextTick(() => {
              this.initDrawPlotLine();
            });
          }

          // loadMask 제거
          this.isLoading = false;
        });
      } else {
        ChartAPI.getPerformanceChartRawData(params, chartConfig).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.options.series = result;
            if (!isEmpty(result[0].rscInfo)) {
              this.rscUnit = result[0].rscInfo.rscUnit;
              chartUtils.setYAxisRange(this.options);
            }
            this.$nextTick(() => {
              this.initDrawPlotLine();
            });
          }

          // loadMask 제거
          this.isLoading = false;
        });
      }
    },
    /**
     * 서버 호출 후 plotLine을 그려준다.
     * @return {[type]} [description]
     * @author jda
     */
    initDrawPlotLine() {
      if (isEmpty(this.plotLineDatetime)) {
        this.setCustomTooltip('init');
      } else {
        this.setPlotLine(this.plotLineDatetime);
        this.setCustomTooltip('plotLine');
      }
    },
    /**
     * 범례에 표현할 이름을 반환한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertLegendName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.userOptions.rscInfo;
      if (!isEmpty(rscInfo)) {
        return isEmpty(rscInfo.rscKey) ? `${rscInfo.rscName}` : `${rscInfo.rscName} ${rscInfo.rscKeyName}`;
      }
      return series.name;
    },
    /**
     * 범례의 장비명을 표현한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertObjName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.userOptions.rscInfo;
      return isEmpty(rscInfo) ? null : rscInfo.objName;
    },
    /**
     * 차트의 시리즈를 삭제한다.
     * 차트의 새로고침 기능을 위해(삭제여부를 알아야함) override함
     * @param  {[type]} point [description]
     * @return {[type]}       [description]
     * @author jda
     */
    onDeleteSeries(point) {
      // 시리즈 삭제 시 차트의 시리즈와 범례도 삭제되도록 한다.
      remove(this.legendPoints, point);

      const chart = this.$refs.highchart.chart;
      const deleteSeries = find(chart.series, point.series);

      const rscInfo = pick(deleteSeries.userOptions.rscInfo, ['objId', 'rsctypeId', 'rscId', 'rscKey', 'managetypeId']);
      const deleteRscInfo = find(this.rscItems, matches(rscInfo));
      deleteRscInfo.deleted = true;

      deleteSeries.remove();

      // 시리즈 삭제 후 비활성화 된 범례 및 시리즈를 활성화 한다.
      const legendPoints = this.legendPoints;
      if (legendPoints.length >= 8) {
        for (let i = 0; i < legendPoints.length; i += 1) {
          if (!legendPoints[i].series.visible) {
            legendPoints[i].series.setVisible(true, false);
            break;
          }
        }
      }
    },
    /**
     * 차트 내부의 버튼 표현
     * @return {[type]} [description]
     * @author jda
     */
    onShowChartButton() {
      // 차트 크게보기에서는 동작하지 않도록 한다.
      if (this.deleteFlag) {
        this.isShowChartButton = true;
      }
    },
    /**
     * 차트 내부의 버튼 숨김
     * @return {[type]} [description]
     * @author jda
     */
    onHideChartButton() {
      this.isShowChartButton = false;
    },
    /**
     * [Smart 분석] 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickForecastButton() {
      const chart = this.$refs.highchart.chart;
      const objRscKeyList = [];
      const rscInfoList = map(chart.series, 'userOptions.rscInfo');
      forEach(rscInfoList, (item) => {
        objRscKeyList.push({
          objId: item.objId,
          managetypeId: item.managetypeId,
          rsctypeId: item.rsctypeId,
          rscId: item.rscId,
          rscKey: item.rscKey,
        });
      });
      this.$store.dispatch('openResourceSmartAnalyzerPopup', objRscKeyList);
    },
    /**
     * [기간비교 그래프] 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickCompareButton() {
      // 삭제된 자원은 기간비교 그래프에 표현하지 않는다.
      const rscItems = [];
      this.rscItems.forEach((record) => {
        if (!record.deleted) {
          rscItems.push(record);
        }
      });
      this.periodRscInfoList = Object.assign(rscItems, { statType: this.statTypeFlag ? this.statType : null }, this.analysisDateParams);
      this.$refs.comparePeriodPopup.open();
    },
    /**
     * 화면에서 차트를 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onDeleteChart() {
      this.$emit('deleteChart', this.$refs.highchart.chart);
    },
    /**
     * 차트를 새로고침한다.
     * @return {[type]} [description]
     * @author jda
     */
    onRefreshChart() {
      // 삭제되거나 추가된 시리즈는 삭제 후 재로딩
      const rscItems = [];
      this.rscItems.forEach((record) => {
        delete record.deleted;
        if (!record.added) {
          rscItems.push(record);
        }
      });
      this.rscItems = rscItems;
      const chart = this.$refs.highchart.chart;
      this.$emit('updateChart', chart, this.orderbyIndex, rscItems);
      this.requestPerformanceChartData(rscItems);
    },
    /**
     * [실시간 차트]버튼을 클릭하여 실시간 성능 데이터 정보를 가져온다.
     * 2019. 9. .11 - filter시 rscKey === '_'를 대상으로 하면 E2E 및 rscKey가 다른 값일 경우 전달하는 파라미터가 누락되는 현상 수정
     * @return {[type]} [description]
     * @author jda - Song
     */
    onClickRealtimeButton() {
      this.showPause = true;
      this.showStop = true;
      const realtimeRscInfoList = filter(this.rscItems, (item) => !item.deleted);
      // const realtimeRscInfoList = filter(this.rscItems, (item) => item.rscKey === '_' && !item.deleted);
      this.realtimeChartTask = `realtimeChartTask-${this.orderbyIndex}`;
      this.$taskManager.createTask(this.realtimeChartTask, 1, () => {
        ChartAPI.getRealtimeResourceData(realtimeRscInfoList, new Date().getTime()).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            let realtimeSeries = cloneDeep(this.realtimeSeries);
            const checkDatetime = result[0].data[0][0];

            if (isEmpty(realtimeSeries)) {
              result.forEach((series) => {
                series.data[0][1] = isNil(series.data[0][1]) ? 0 : series.data[0][1];
              });
              realtimeSeries = result;
            } else {
              result.forEach((series) => {
                const findItem = find(realtimeSeries, { rscInfo: series.rscInfo });
                // 실시간 성능 데이터가 30개가 넘어가면 앞에서부터 pop하여 최대 30개로 맞춘다.
                if (findItem.data.length >= 50) {
                  pullAt(findItem.data, 0);
                }
                if (isNil(series.data[0][1])) {
                  const lastIndex = findItem.data.length - 1;
                  const lastValue = findItem.data[lastIndex][1];

                  series.data[0][1] = lastValue;
                }
                findItem.data.push(series.data[0]);
              });
            }
            if (checkDatetime < this.lastCheckDatetime) {
              realtimeSeries.forEach((series) => {
                series.data = sortBy(series.data, (a) => a[0]);
              });
            }
            this.realtimeSeries = realtimeSeries;
            this.options.series = this.realtimeSeries;
            this.lastCheckDatetime = checkDatetime;

            this.$nextTick(() => {
              this.setCustomTooltip('init');
            });
          }
        });
      });
      this.$taskManager.startTask(this.realtimeChartTask);
    },
    /**
     * 실시간 성능 정보 조회를 중지한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickRealtimeStopButton() {
      this.showStop = false;
      this.showPause = false;

      this.$taskManager.removeTask(this.realtimeChartTask);
      remove(this.realtimeSeries);

      this.onShowChart();
    },
    /**
     * 실시간 차트 조회 일시중지
     * @return {[type]} [description]
     * @author jda
     */
    onClickPauseButton() {
      this.showPause = false;
      this.$taskManager.stopTask(this.realtimeChartTask);
    },
    onChangeStatType() {
      this.onShowChart();
    },
    /**
     * 통계타입 - statType 추가에 따라 버튼 hidden 플래그 추가
     * @return {[type]} [description]
     * @author Song
     */
    onVisibleChangeSelect(visible) {
      this.selectHiddenFlag = visible;
    },
    sortBy,
  },
};
</script>

<style lang="scss" scoped>
.highcharts-container {
  width: 100% !important;
}

.chart-button-wrapper{
  display: flex;
  position: absolute;
  width: calc(100% - 334px);
  max-height: 30px;
  margin-left: 60px;
  margin-right: 20px;

  .chart-button {
    z-index: 1;
  }
}

.tooltip {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/chart/components/chart/CommonLineChart.vue